module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs performance"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("分配详情")]), _vm._v(" "), _c('ul', {
    staticClass: "desc-list"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("分配总人数：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.count) + "人")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("项目总金额：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.amount) + _vm._s(_vm.unit))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("已分配金额：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.fixedAmount(_vm.totalMoney)) + _vm._s(_vm.unit))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("未分配金额：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.fixedAmount(_vm.unMoney)) + _vm._s(_vm.unit))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("已分配比例：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm._f("fixed2")(_vm.totalPercent)) + "%")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("未分配比例：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm._f("fixed2")(_vm.unPercent)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("分配列表")]), _vm._v(" "), _c('el-table', {
    class: {
      active: _vm.editStatus
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "头像",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          attrs: {
            "width": "50",
            "height": "50",
            "src": scope.row.userAvatar
          }
        }), _vm._v(" "), (scope.row.isSign) ? _c('i', {
          staticClass: "ico web-icon-ismain"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "员工姓名",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text"
        }, [_vm._v(_vm._s(scope.row.userName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分配比例",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.editStatus),
            expression: "!editStatus"
          }],
          staticClass: "normal"
        }, [_vm._v(_vm._s(scope.row.rate))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.editStatus),
            expression: "editStatus"
          }, {
            name: "model",
            rawName: "v-model.lazy.number",
            value: (scope.row.rate),
            expression: "scope.row.rate",
            modifiers: {
              "lazy": true,
              "number": true
            }
          }],
          staticClass: "v-input",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (scope.row.rate)
          },
          on: {
            "change": [function($event) {
              _vm.$set(scope.row, "rate", _vm._n($event.target.value))
            }, function($event) {
              _vm.handleChange(scope.$index, 'rate')
            }],
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "text"
        }, [_vm._v("%")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '分配金额' + _vm.unit,
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.editStatus),
            expression: "!editStatus"
          }],
          staticClass: "normal"
        }, [_vm._v(_vm._s(scope.row.amount))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.editStatus),
            expression: "editStatus"
          }, {
            name: "model",
            rawName: "v-model.lazy.number",
            value: (scope.row.amount),
            expression: "scope.row.amount",
            modifiers: {
              "lazy": true,
              "number": true
            }
          }],
          staticClass: "v-input",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (scope.row.amount)
          },
          on: {
            "change": [function($event) {
              _vm.$set(scope.row, "amount", _vm._n($event.target.value))
            }, function($event) {
              _vm.handleChange(scope.$index, 'amount')
            }],
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "del",
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.$index, scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.editStatus = !_vm.editStatus
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [(_vm.editStatus) ? [_vm._v("退出")] : _vm._e(), _vm._v("编辑\n      ")], 2)]) : _vm._e(), _vm._v(" "), (_vm.editStatus) ? _c('div', {
    staticClass: "button-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addPerformance
    }
  }, [_vm._v("添加分配人")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.closeDialog),
      expression: "closeDialog"
    }],
    staticClass: "custom-dropbox"
  }, [_c('v-dropbox', {
    attrs: {
      "type": 1
    },
    on: {
      "staff": _vm.getStaff
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e226f70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/contract/performance.vue
// module id = 1321
// module chunks = 82